import React from 'react';
import classNames from 'classnames';

export const ListingHeading = ({ primaryText, secondaryText, className }) => (
  <div className={classNames('org-listing__user-text', className)}>
    <h1>{primaryText}</h1>
    {!!secondaryText && <p>{secondaryText}</p>}
  </div>
);
